document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-quick-shop-link").forEach((button) => {
    button.addEventListener("click", (e) => {
      const productId = button.dataset.id;
      const modal = document.querySelector(
        `product-modal[data-product-id="${productId}"]`
      );
      if (modal) {
        modal.classList.add("active");
        modal.classList.remove("hidden");
      }
    });
  });
});
